import React from "react";
import { withRouter } from "react-router-dom";
import CONSTANT from "./../../../constant";
import Loader from "./../../../component/common/Loader";
import AparEmployeeHeader, { normalizeManagers, mergeManagerData } from "./../../../component/common/AparEmployeeHeader";
import { getKpiReport, getKpiTaskGrade, saveKpiTaskGrade, updateKpiTaskGrade } from "./../../../actions/AppraisalCycleAction";


class aparReportingManagerForm2 extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      showLoader: false,
      employeeData: null,
      form1Data: null,
      kpiReportId: null,
      reportingAssessmentId: null,
      hasExistingGrades: false,
      isSubmitted: false,
      isMouApplicable: false,
      mouTask: null,
      otherKeyTasks: [],
      // Reporting Authority grading
      mouGrade: '',
      mouWeightedGrade: 0,
      taskGrades: [] as any[],
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Assessment of Achievements - " + CONSTANT.organisation.name;

    const locationState = this.props.location?.state || {};
    const { form1Data, reportingAssessmentId, kpiReportId: passedKpiReportId, employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo } = locationState;
    const employeeData = { employeeCode, employeeName, employeeNumber, effectiveFrom, effectiveTo, ...normalizeManagers(locationState) };

    this.setState({ employeeData, form1Data, reportingAssessmentId, showLoader: true });

    // Fetch HR's KPI report to show employee data
    if (employeeCode && effectiveFrom) {
      getKpiReport({ employeeCode, effectiveFrom, reportType: 'employee' }).then((res: any) => {
        const report = res?.result || null;
        if (report) {
          const kpiReportId = report.id || passedKpiReportId || null;
          const mouTask = report.tasks?.find((t: any) => t.particular === '*)') || null;
          const otherTasks = report.tasks?.filter((t: any) => t.particular !== '*)') || [];
          const isMouApplicable = !!mouTask;

          this.setState((prev: any) => ({
            kpiReportId,
            isMouApplicable,
            mouTask,
            otherKeyTasks: otherTasks,
            taskGrades: otherTasks.map((t: any) => ({ kpiTaskId: t.id, grade: '', weightedGrade: 0 })),
            employeeData: { ...prev.employeeData, ...mergeManagerData(prev.employeeData, report) },
          }), () => {
            if (kpiReportId) {
              this.loadExistingGrades(kpiReportId);
            } else {
              this.setState({ showLoader: false });
            }
          });
        } else {
          this.setState({ showLoader: false });
        }
      });
    } else {
      this.setState({ showLoader: false });
    }
  }

  loadExistingGrades = (kpiReportId: any) => {
    getKpiTaskGrade({ kpiReportId, gradedByRole: "reporting" }).then((res: any) => {
      const resData = res?.result || res;
      const grades = resData?.grades || (Array.isArray(resData) ? resData : []);
      const isSubmitted = !!resData?.is_submitted;
      if (grades.length > 0) {
        const { mouTask, otherKeyTasks } = this.state;

        // Map existing grades by kpi_task_id
        const gradeMap: any = {};
        grades.forEach((g: any) => {
          gradeMap[g.kpi_task_id] = g;
        });

        // Pre-fill MOU grade
        let mouGrade = '';
        let mouWeightedGrade = 0;
        if (mouTask && gradeMap[mouTask.id]) {
          mouGrade = String(gradeMap[mouTask.id].absolute_grade || '');
          mouWeightedGrade = parseFloat(gradeMap[mouTask.id].weighted_grade) || 0;
        }

        // Pre-fill other task grades
        const taskGrades = otherKeyTasks.map((t: any) => {
          const existing = gradeMap[t.id];
          if (existing) {
            return { kpiTaskId: t.id, grade: String(existing.absolute_grade || ''), weightedGrade: parseFloat(existing.weighted_grade) || 0 };
          }
          return { kpiTaskId: t.id, grade: '', weightedGrade: 0 };
        });

        this.setState({
          hasExistingGrades: true,
          isSubmitted,
          mouGrade,
          mouWeightedGrade,
          taskGrades,
          showLoader: false,
        });
      } else {
        this.setState({ showLoader: false });
      }
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleMouGradeChange = (value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const weightage = parseFloat(this.state.mouTask?.weightage) || 0;
    this.setState({ mouGrade: clampedValue, mouWeightedGrade: (weightage * grade) / 10 });
  };

  handleTaskGradeChange = (index: number, value: string) => {
    let grade = parseFloat(value) || 0;
    if (grade > 10) grade = 10;
    if (grade < 0) grade = 0;
    const clampedValue = grade > 0 ? String(grade) : value;
    const taskGrades = [...this.state.taskGrades];
    const weightage = parseFloat(this.state.otherKeyTasks[index]?.weightage) || 0;
    taskGrades[index] = { ...taskGrades[index], grade: clampedValue, weightedGrade: (weightage * grade) / 10 };
    this.setState({ taskGrades });
  };

  calculateTasksTotal = () => {
    return this.state.taskGrades.reduce((sum: number, t: any) => sum + (t.weightedGrade || 0), 0);
  };

  // KPI grand total (out of 75) = MoU weighted grade (if applicable) + other tasks total.
  calculateGrandTotal = () => {
    const { isMouApplicable, mouWeightedGrade } = this.state;
    return (isMouApplicable ? (parseFloat(mouWeightedGrade) || 0) : 0) + this.calculateTasksTotal();
  };

  validateGrades = () => {
    const { isMouApplicable, mouGrade, taskGrades } = this.state;

    if (isMouApplicable && (!mouGrade || parseFloat(mouGrade) <= 0)) {
      alert("Please enter a grade for MoU target.");
      return false;
    }

    for (let i = 0; i < taskGrades.length; i++) {
      if (!taskGrades[i].grade || parseFloat(taskGrades[i].grade) <= 0) {
        alert(`Please enter a grade for task ${i + 1}.`);
        return false;
      }
    }

    return true;
  };

  buildGradesPayload = () => {
    const { kpiReportId, isMouApplicable, mouTask, mouGrade, taskGrades } = this.state;
    const grades: any[] = [];
    if (isMouApplicable && mouTask) {
      grades.push({ kpiTaskId: mouTask.id, absoluteGrade: parseFloat(mouGrade) || 0 });
    }
    taskGrades.forEach((t: any) => {
      grades.push({ kpiTaskId: t.kpiTaskId, absoluteGrade: parseFloat(t.grade) || 0 });
    });
    return { kpiReportId, gradedByRole: "reporting", grades };
  };

  callGradeApi = (callback: () => void) => {
    const { kpiReportId, hasExistingGrades } = this.state;
    if (!kpiReportId) {
      alert("KPI Report ID not found. Please go back and try again.");
      return;
    }
    this.setState({ showLoader: true });
    const payload = this.buildGradesPayload();
    const apiCall = hasExistingGrades ? updateKpiTaskGrade(payload) : saveKpiTaskGrade(payload);
    apiCall.then(() => {
      this.setState({ showLoader: false, hasExistingGrades: true });
      callback();
    }).catch(() => {
      this.setState({ showLoader: false });
    });
  };

  handleSaveDraft = () => {
    this.callGradeApi(() => {
      alert('Saved as draft.');
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();

    if (!this.validateGrades()) return;

    const { employeeData, form1Data, reportingAssessmentId } = this.state;

    this.callGradeApi(() => {
      this.props.history.push({
        pathname: CONSTANT.component.aparReportingManagerForm3.url,
        state: {
          ...employeeData,
          reportingAssessmentId,
          form1Data,
          kpiReportId: this.state.kpiReportId,
          kpiTotal: this.calculateGrandTotal(),
        },
      });
    });
  };

  render() {
    const { showLoader, employeeData, isMouApplicable, mouTask, otherKeyTasks, mouGrade, mouWeightedGrade, taskGrades, isSubmitted } = this.state;

    const tasksTotal = this.calculateTasksTotal();
    const grandTotal = this.calculateGrandTotal();

    return (
      <div className="container mx-auto px-4 py-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <div className="row mb-3">
                  <div className="col-md-8">
                    <h1 className="page-title">Assessment of Achievements</h1>
                  </div>
                  <div className="col-md-4 text-right">
                    <button type="button" className="btn btn-sm cancel-button" onClick={() => this.props.history.goBack()}>
                      <i className="fa fa-arrow-left mr-2" />Back
                    </button>
                  </div>
                </div>
                <AparEmployeeHeader {...employeeData} detailViewerRole="reporting" kpiReportId={this.state.kpiReportId} />

                {showLoader && <Loader />}

                {isSubmitted && (
                  <div className="alert alert-success mt-2">
                    <i className="fa fa-check-circle mr-1" /> This assessment has been submitted and is now view-only.
                  </div>
                )}

                <div>
                  <h2 className="fs-5 fw-bold border-bottom pb-2 mb-4">
                    Assessment of Achievements against Targets
                  </h2>

                  <p className="text-muted mb-3">
                    This assessment should rate the officer vis-à-vis his peers and not the general population. Grades should be assigned on a scale of <strong>1-10</strong>, in maximum of <strong>2 decimal numbers</strong>, with <strong>10</strong> referring to the best grade and <strong>1</strong> to the lowest grade. Weightage to this Section will be <strong>75%</strong>.
                  </p>

                  <div className="table-responsive mb-2">
                    <table className="table table-bordered table-sm align-middle">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: '40%' }}>Particulars</th>
                          <th style={{ width: '15%' }}>Weightage (a)</th>
                          <th style={{ width: '20%' }}>Absolute Grade (b)</th>
                          <th style={{ width: '25%' }}>Weighted Grade (c = a x b/10)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* MOU Targets Section */}
                        <tr className="table-secondary">
                          <td colSpan={4} className="fw-semibold">I – MoU Targets</td>
                        </tr>

                        {isMouApplicable && mouTask ? (
                          <tr>
                            <td>
                              <div className="d-flex align-items-center gap-2">
                                <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>*)</span>
                                <input type="text" className="form-control form-control-sm" value={mouTask.task_description || ''} readOnly />
                              </div>
                            </td>
                            <td>
                              <input type="number" className="form-control form-control-sm text-center" value={mouTask.weightage || ''} readOnly />
                            </td>
                            <td>
                              <input
                                type="number"
                                step="0.01"
                                min="1"
                                max="10"
                                value={mouGrade}
                                onChange={(e) => this.handleMouGradeChange(e.target.value)}
                                className="form-control form-control-sm text-center"
                                placeholder="0.00"
                                required
                                disabled={isSubmitted}
                              />
                            </td>
                            <td>
                              <input type="text" className="form-control form-control-sm text-center" value={(parseFloat(mouWeightedGrade) || 0).toFixed(2)} readOnly />
                            </td>
                          </tr>
                        ) : (
                          <tr>
                            <td colSpan={4} className="text-muted fst-italic ps-3 small">
                              MoU not applicable
                            </td>
                          </tr>
                        )}

                        {/* Other Key Tasks Section */}
                        <tr className="table-secondary">
                          <td colSpan={4} className="fw-semibold">II – Other Key Assigned Tasks flowing from KPI</td>
                        </tr>

                        {otherKeyTasks.length === 0 ? (
                          <tr>
                            <td colSpan={4} className="text-muted fst-italic ps-3 small">
                              No tasks available.
                            </td>
                          </tr>
                        ) : (
                          otherKeyTasks.map((task: any, idx: number) => (
                            <tr key={task.id}>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <span className="text-muted fw-semibold" style={{ minWidth: '36px' }}>{task.particular}</span>
                                  <input type="text" className="form-control form-control-sm" value={task.task_description || ''} readOnly />
                                </div>
                              </td>
                              <td>
                                <input type="number" className="form-control form-control-sm text-center" value={task.weightage || ''} readOnly />
                              </td>
                              <td>
                                <input
                                  type="number"
                                  step="0.01"
                                  min="1"
                                  max="10"
                                  value={taskGrades[idx]?.grade || ''}
                                  onChange={(e) => this.handleTaskGradeChange(idx, e.target.value)}
                                  className="form-control form-control-sm text-center"
                                  placeholder="0.00"
                                  required
                                  disabled={isSubmitted}
                                />
                              </td>
                              <td>
                                <input type="text" className="form-control form-control-sm text-center" value={(parseFloat(taskGrades[idx]?.weightedGrade) || 0).toFixed(2)} readOnly />
                              </td>
                            </tr>
                          ))
                        )}

                        {/* Total Row */}
                        <tr className="table-light fw-semibold">
                          <td className="text-end pe-3">Total (i to v)</td>
                          <td className="text-center">{tasksTotal > 0 ? (parseFloat(tasksTotal) || 0).toFixed(2) : ''}</td>
                          <td></td><td></td>
                        </tr>

                        {/* Grand Total Row */}
                        <tr className="table-secondary fw-bold">
                          <td className="text-end pe-3">Grand Total I & II</td>
                          <td className="text-center">75</td>
                          <td></td>
                          <td className="text-center">{(parseFloat(grandTotal) || 0).toFixed(2)}</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                  <div className="border p-2 mt-2 mb-3 fst-italic text-danger small">
                    <p className="mb-1">Weighted grade is to be computed by multiplying the absolute grade by the weight.</p>
                    <p className="mb-0">Overall grading is to be computed by summing up the weighted grade and rounding off to 2 decimals.</p>
                  </div>

                  <div className="text-muted mt-3 mb-3">
                    <p className="mb-1"><sup>1</sup> The weightage for MoU targets is 75 for Chief Executives, 50 for Functional Directors and Executives at E9 &amp; E8 level.</p>
                    <p className="mb-1"><sup>2</sup> The final MoU score based on audited accounts conveyed by DPE should be filled in this space.</p>
                    <p className="mb-0"><sup>3</sup> The weightage for other assigned tasks flowing from KPI is nil for Chief Executives and 25 for Functional Director &amp; Executives at E9 &amp; E8 level.</p>
                  </div>

                  <div className="d-flex justify-content-end gap-2 mt-3">
                    <button type="button" className="btn btn-outline-secondary" onClick={() => this.props.history.goBack()}>
                      Back
                    </button>
                    {!isSubmitted && (
                      <button type="button" className="btn btn-secondary" onClick={this.handleSaveDraft} disabled={showLoader}>
                        {showLoader ? "Saving..." : "Save Draft"}
                      </button>
                    )}
                    {!isSubmitted && (
                      <button type="button" className="btn btn-primary" onClick={this.onSubmit} disabled={showLoader}>
                        {showLoader ? "Saving..." : "Save & Next"} <i className="fa fa-arrow-right ml-1" />
                      </button>
                    )}
                    {isSubmitted && (
                      <button type="button" className="btn btn-primary" onClick={() => {
                        const { employeeData, kpiReportId, reportingAssessmentId } = this.state;
                        this.props.history.push({
                          pathname: CONSTANT.component.aparReportingManagerForm3.url,
                          state: { ...employeeData, kpiReportId, reportingAssessmentId, kpiTotal: this.calculateGrandTotal() },
                        });
                      }}>
                        Next <i className="fa fa-arrow-right ml-1" />
                      </button>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(aparReportingManagerForm2);
